export default __webpack_public_path__ + "static/media/icon-upload-arrow.c74db426.svg";